import { emergencyExit } from 'src/features/app-exit/emergency-exit';

import { initializeStartupExit } from './startup-exit';

// Keep the emergency control's entire static graph independent of app initialization.
initializeStartupExit();
if (!emergencyExit.getSnapshot().requested) {
  // A failed import reaches the existing HTML safety net via unhandledrejection.
  import('../main-pos');
}
